import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { showUtilModal, showSideBar } from '../../redux/actions/miscActions'
import { checkUserAuthStatus } from '../../redux/actions/userActions'
import SearchBar from './SearchBar';
import NavIcons from './NavIcons'

export class Navbar extends Component {
      
  componentDidMount=()=>{
    this.props.checkUserAuthStatus()
  }
  
  goHome=()=>{
    this.props.history.push('/')
  }

  showMobileMenu=()=>{
    const { pathname } = window.location;
    if(pathname === '/'){
      this.props.showSideBar('filters', 'left')
    }
    if(pathname === '/pakketten'){
      this.props.showSideBar('pakketFilters', 'left')
    }
    if(pathname === '/checkout' || pathname === '/user'){
      this.props.showSideBar('main', 'left')
    }
  }

  render() {
   

    return (
      <div className="navbar">
        <div className="navbar-content">

          <div className="mobile-nav" onClick={this.showMobileMenu}>
            <img src={require('../../assets/icons/menu2.svg')} alt=""/>
          </div>
          
          <div className="vendor-logo" onClick={this.goHome}>
            <img src={require('../../assets/img/bonanza-logo-aangepast.png')} alt=""/>
          </div>
          
          <div className="vendor-logo-mobile" onClick={this.goHome}>
            <img src={require('../../assets/img/Bonanza_logo_menu.png')} alt=""/>
          </div>

          <SearchBar />
          
        <NavIcons />

        </div>
      </div>
    )
  }
}

const mapStateToProps =(state)=> ({
  user: state.user,
  cart: state.cart,
  profile: state.profile
})

export default connect(mapStateToProps, { showUtilModal, checkUserAuthStatus, showSideBar })(withRouter(Navbar))
 